import React from 'react';
import { getEarning } from 'api/provider';
import { Channel } from 'types/common';

let globalData: number | undefined;

const useMyEarning = (): [number | undefined, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<number | undefined>(globalData);
    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getEarning();
            if (!result.error) {
                const data = result?.data?.data || 0;
                globalData = data;
                setItems(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (!items || Object.keys(items).length === 0) {
            if (!loading) {
                fetchData();
            }
        }
    }, []);

    return [items, loading, fetchData];
};

export default useMyEarning;
